module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE RELATIONS")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "mr-10",
    staticStyle: {
      "min-width": "232px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Please choose a teacher first",
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    on: {
      "change": _vm.changeTeacherId
    },
    model: {
      value: (_vm.selectTeacherValue),
      callback: function($$v) {
        _vm.selectTeacherValue = $$v
      },
      expression: "selectTeacherValue"
    }
  }, _vm._l((_vm.teachers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.displayName + ' - ' + item.givenName + ' ' + item.familyName,
        "value": item.displayName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticClass: "input-setMaxWidth select-bg-s",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Trip",
      "disabled": !_vm.selectTeacherValue,
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    model: {
      value: (_vm.selecttripvalue),
      callback: function($$v) {
        _vm.selecttripvalue = $$v
      },
      expression: "selecttripvalue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  })], 1), _vm._v(" "), _c('transfer-box', {
    attrs: {
      "selecttripvalue": _vm.selecttripvalue,
      "t-id": _vm.teacherId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-466d4f29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Relation.vue
// module id = 612
// module chunks = 1